import _ from "lodash";

import uniqueId from "../../utils/uniqueId";
import wrapArrayIfNeeded from "../../utils/wrapArrayIfNeeded";
import dateFunctions from "../definition/calendar/dateFunctions";

const prefix = "appState";

const SELECT_ITEMS = `${prefix}:SELECT_ITEMS`;
const CLEAR_SELECTION = `${prefix}:CLEAR_SELECTION`;
const ADD_ITEMS_TO_SELECTION = `${prefix}:ADD_ITEMS_TO_SELECTION`;
const REMOVE_ITEMS_FROM_SELECTION = `${prefix}:REMOVE_ITEMS_FROM_SELECTION`;
const SELECT_MARKER = `${prefix}:SELECT_MARKER`;

// Desktop Split View Manipulation
const REPLACE_OPEN_VIEWS = `${prefix}:REPLACE_OPEN_VIEWS`;
const ADD_VIEW = `${prefix}:ADD_VIEW`;
const SPLIT_VIEW_HORIZONTAL = `${prefix}:SPLIT_VIEW_HORIZONTAL`;
const SPLIT_VIEW_VERTICAL = `${prefix}:SPLIT_VIEW_VERTICAL`;
const POPOUT_VIEW = `${prefix}:POPOUT_VIEW`;
const MINIMIZE_VIEW = `${prefix}:MINIMIZE_VIEW`;
const REMOVE_VIEW = `${prefix}:REMOVE_VIEW`;
const REMOVE_OTHER_VIEWS = `${prefix}:REMOVE_OTHER_VIEWS`;
const RESIZE_VIEWS = `${prefix}:RESIZE_VIEWS`;

// Tablet Split View Manipulation
const SET_LAYOUT_SINGLE_VIEW = `${prefix}:SET_LAYOUT_SINGLE_VIEW`;
const SET_LAYOUT_TWO_VIEW_STACK = `${prefix}:SET_LAYOUT_TWO_VIEW_STACK`;
const SET_LAYOUT_TWO_VIEW_STACK_THIRDS = `${prefix}:SET_LAYOUT_TWO_VIEW_STACK_THIRDS`;
const SET_LAYOUT_TWO_VIEW_SIDE = `${prefix}:SET_LAYOUT_TWO_VIEW_SIDE`;

// Configuring what is within the views
const SET_ACTIVE_VIEW = `${prefix}:SET_ACTIVE_VIEW`;
const SET_NEXT_ACTIVE_VIEW = `${prefix}:SET_NEXT_ACTIVE_VIEW`;
const SWITCH_VIEW_TYPE = `${prefix}:SWITCH_VIEW_TYPE`;
const LOCK_SCROLLING = `${prefix}:LOCK_SCROLLING`;
const UNLOCK_SCROLLING = `${prefix}:UNLOCK_SCROLLING`;

// Mobile version of above
const SWITCH_MOBILE_PORTRAIT_VIEW_TYPE = `${prefix}:SWITCH_MOBILE_PORTRAIT_VIEW_TYPE`;
const SWITCH_MOBILE_LANDSCAPE_VIEW_TYPE = `${prefix}:SWITCH_MOBILE_LANDSCAPE_VIEW_TYPE`;
const TOGGLE_EXPAND_SUPER_ITEM_MOBILE_LIST = `${prefix}:TOGGLE_EXPAND_SUPER_ITEM_MOBILE_LIST`;

const TOGGLE_RELATIONSHIP_COLUMN = `${prefix}:TOGGLE_RELATIONSHIP_COLUMN`;
const TOGGLE_EXPAND_SUPER_ITEM = `${prefix}:TOGGLE_EXPAND_SUPER_ITEM`;
const CHANGE_ZOOM_SLIDER = `${prefix}:CHANGE_ZOOM_SLIDER`;
const DEFAULT_SCROLL_POSITION_TO_TIMESTAMP = `${prefix}:DEFAULT_SCROLL_POSITION_TO_TIMESTAMP`;
const RECORD_SCROLL_AND_ZOOM = `${prefix}:RECORD_SCROLL_AND_ZOOM`;
const MOVE_TIMELINE_SCROLL_POSITIONS = `${prefix}:MOVE_TIMELINE_SCROLL_POSITIONS`;

const TOGGLE_OUTLINE_COLUMN = `${prefix}:TOGGLE_OUTLINE_COLUMN`;
const RESIZE_OUTLINE_COLUMN = `${prefix}:RESIZE_OUTLINE_COLUMN`;
const MOVE_OUTLINE_COLUMN = `${prefix}:MOVE_OUTLINE_COLUMN`;

const TOGGLE_SPREADSHEET_COLUMN = `${prefix}:TOGGLE_SPREADSHEET_COLUMN`;
const RESIZE_SPREADSHEET_COLUMN = `${prefix}:RESIZE_SPREADSHEET_COLUMN`;
const MOVE_SPREADSHEET_COLUMN = `${prefix}:MOVE_SPREADSHEET_COLUMN`;
const SET_SPREADSHEET_SORT_BY = `${prefix}:SET_SPREADSHEET_SORT_BY`;

const SET_SUBWAY_DISPLAY = `${prefix}:SET_SUBWAY_DISPLAY`;

const TOGGLE_ENTITY_LIST = `${prefix}:TOGGLE_ENTITY_LIST`;
const OPEN_ENTITY_LIST = `${prefix}:OPEN_ENTITY_LIST`;
const TOGGLE_ENTITY_LIST_ITEM = `${prefix}:TOGGLE_ENTITY_LIST_ITEM`;

const HIDE_LEFT_PANEL = `${prefix}:HIDE_LEFT_PANEL`;

const HIDE_DESKTOP_LEFT_PANEL = `${prefix}:HIDE_DESKTOP_LEFT_PANEL`;
const HIDE_TABLET_LEFT_PANEL = `${prefix}:HIDE_TABLET_LEFT_PANEL`;
const HIDE_MOBILE_LEFT_PANEL = `${prefix}:HIDE_MOBILE_LEFT_PANEL`;

const SET_LEFT_PANEL_MODE = `${prefix}:SET_LEFT_PANEL_MODE`;
const TOGGLE_SEARCH_PANEL = `${prefix}:TOGGLE_SEARCH_PANEL`;
const OPEN_SEARCH_PANEL = `${prefix}:OPEN_SEARCH_PANEL`;
const TOGGLE_FILTER_PANEL = `${prefix}:TOGGLE_FILTER_PANEL`;
const TOGGLE_GLOBAL_FILTER_PANEL = `${prefix}:TOGGLE_GLOBAL_FILTER_PANEL`;
const TOGGLE_LOCAL_FILTER_PANEL = `${prefix}:TOGGLE_LOCAL_FILTER_PANEL`;
const OPEN_LOCAL_FILTER_PANEL = `${prefix}:OPEN_LOCAL_FILTER_PANEL`;
const TOGGLE_SETTINGS_PANEL = `${prefix}:TOGGLE_SETTINGS_PANEL`;
const TOGGLE_HARVARD_SETTINGS_PANEL = `${prefix}:TOGGLE_HARVARD_SETTINGS_PANEL`;
const TOGGLE_SCROLL_TO_DATE_PANEL = `${prefix}:TOGGLE_SCROLL_TO_DATE_PANEL`;

const SET_LEFT_PANEL_WIDTH = `${prefix}:SET_LEFT_PANEL_WIDTH`;
const SET_PANEL_WIDTHS = `${prefix}:SET_PANEL_WIDTHS`;

const COLLAPSE_FILTER_GROUP = `${prefix}:COLLAPSE_FILTER_GROUP`;
const EXPAND_FILTER_GROUP = `${prefix}:EXPAND_FILTER_GROUP`;
const CHANGE_SEARCH_FOR_TYPE = `${prefix}:CHANGE_SEARCH_FOR_TYPE`;

const TOGGLE_SUBWAY_THREAD = `${prefix}:TOGGLE_SUBWAY_THREAD`;

const TOGGLE_TIMELINE_GROUP = `${prefix}:TOGGLE_TIMELINE_GROUP`;
const REMOVE_TIMELINE_GROUP_FROM_ALL_VIEWS = `${prefix}:REMOVE_TIMELINE_GROUP_FROM_ALL_VIEWS`;
const CLEAR_TIMELINE_GROUPS = `${prefix}:CLEAR_TIMELINE_GROUP`;

const SET_FONT_PERCENTAGE = `${prefix}:SET_FONT_PERCENTAGE`;

const USER_INTERFACE_ACTION_PERFORMED = `${prefix}:USER_INTERFACE_ACTION_PERFORMED`;

const ADD_EXPOSED_FILTER_TYPE = `${prefix}:ADD_EXPOSED_FILTER_TYPE`;
const REMOVE_EXPOSED_FILTER_TYPE = `${prefix}:REMOVE_EXPOSED_FILTER_TYPE`;

export const actionTypes = {
  SELECT_ITEMS,
  CLEAR_SELECTION,
  ADD_ITEMS_TO_SELECTION,
  REMOVE_ITEMS_FROM_SELECTION,
  SELECT_MARKER,
  REPLACE_OPEN_VIEWS,
  ADD_VIEW,
  SPLIT_VIEW_HORIZONTAL,
  SPLIT_VIEW_VERTICAL,
  MINIMIZE_VIEW,
  REMOVE_VIEW,
  REMOVE_OTHER_VIEWS,
  POPOUT_VIEW,

  SET_LAYOUT_SINGLE_VIEW,
  SET_LAYOUT_TWO_VIEW_STACK,
  SET_LAYOUT_TWO_VIEW_STACK_THIRDS,
  SET_LAYOUT_TWO_VIEW_SIDE,

  SET_ACTIVE_VIEW,
  SET_NEXT_ACTIVE_VIEW,
  SWITCH_VIEW_TYPE,
  RESIZE_VIEWS,
  LOCK_SCROLLING,
  UNLOCK_SCROLLING,

  SWITCH_MOBILE_PORTRAIT_VIEW_TYPE,
  SWITCH_MOBILE_LANDSCAPE_VIEW_TYPE,
  TOGGLE_EXPAND_SUPER_ITEM_MOBILE_LIST,

  // ZOOM_TIMELINE,
  TOGGLE_RELATIONSHIP_COLUMN,
  TOGGLE_EXPAND_SUPER_ITEM,
  CHANGE_ZOOM_SLIDER,
  DEFAULT_SCROLL_POSITION_TO_TIMESTAMP,
  RECORD_SCROLL_AND_ZOOM,
  MOVE_TIMELINE_SCROLL_POSITIONS,

  TOGGLE_OUTLINE_COLUMN,
  RESIZE_OUTLINE_COLUMN,
  MOVE_OUTLINE_COLUMN,
  SET_SPREADSHEET_SORT_BY,

  TOGGLE_SPREADSHEET_COLUMN,
  RESIZE_SPREADSHEET_COLUMN,
  MOVE_SPREADSHEET_COLUMN,

  SET_SUBWAY_DISPLAY,

  TOGGLE_ENTITY_LIST,
  OPEN_ENTITY_LIST,
  TOGGLE_ENTITY_LIST_ITEM,
  TOGGLE_SEARCH_PANEL,
  OPEN_SEARCH_PANEL,
  TOGGLE_FILTER_PANEL,
  TOGGLE_GLOBAL_FILTER_PANEL,
  TOGGLE_LOCAL_FILTER_PANEL,
  OPEN_LOCAL_FILTER_PANEL,
  TOGGLE_SETTINGS_PANEL,
  TOGGLE_HARVARD_SETTINGS_PANEL,
  TOGGLE_SCROLL_TO_DATE_PANEL,

  HIDE_LEFT_PANEL,

  HIDE_DESKTOP_LEFT_PANEL,
  HIDE_TABLET_LEFT_PANEL,
  HIDE_MOBILE_LEFT_PANEL,

  SET_LEFT_PANEL_MODE,
  SET_LEFT_PANEL_WIDTH,
  SET_PANEL_WIDTHS,

  COLLAPSE_FILTER_GROUP,
  EXPAND_FILTER_GROUP,

  CHANGE_SEARCH_FOR_TYPE,

  TOGGLE_SUBWAY_THREAD,

  TOGGLE_TIMELINE_GROUP,
  CLEAR_TIMELINE_GROUPS,
  REMOVE_TIMELINE_GROUP_FROM_ALL_VIEWS,

  SET_FONT_PERCENTAGE,

  USER_INTERFACE_ACTION_PERFORMED,

  ADD_EXPOSED_FILTER_TYPE,
  REMOVE_EXPOSED_FILTER_TYPE
};

const selectItems = ids => {
  return {
    type: SELECT_ITEMS,
    ids: wrapArrayIfNeeded(ids)
  };
};

const clearSelection = () => {
  return {
    type: CLEAR_SELECTION
  };
};

const addItemsToSelection = ids => {
  return {
    type: ADD_ITEMS_TO_SELECTION,
    ids: wrapArrayIfNeeded(ids)
  };
};

const removeItemsFromSelection = ids => {
  return {
    type: REMOVE_ITEMS_FROM_SELECTION,
    ids: wrapArrayIfNeeded(ids)
  };
};

const selectMarker = id => {
  return {
    type: SELECT_MARKER,
    id
  };
};

const replaceOpenViews = (openViews, layoutIdentifier) => {
  return {
    type: REPLACE_OPEN_VIEWS,
    openViews,
    layoutIdentifier
  };
};

const addView = direction => {
  return {
    type: ADD_VIEW,
    viewId: uniqueId(),
    direction
  };
};

// viewChanges should be { viewId: { width, height}, viewId2: { width, height} }
const resizeViews = viewChanges => {
  return {
    type: RESIZE_VIEWS,
    viewChanges
  };
};

const splitViewHorizontal = splittingViewId => {
  return {
    type: SPLIT_VIEW_HORIZONTAL,
    viewId: uniqueId(),
    splittingViewId
  };
};

const splitViewVertical = splittingViewId => {
  return {
    type: SPLIT_VIEW_VERTICAL,
    viewId: uniqueId(),
    splittingViewId
  };
};

const minimizeView = viewId => {
  return {
    type: MINIMIZE_VIEW,
    viewId
  };
};

const removeView = viewId => {
  return {
    type: REMOVE_VIEW,
    viewId
  };
};

const removeOtherViews = () => {
  return {
    type: REMOVE_OTHER_VIEWS
  };
};

const popoutView = viewId => {
  return {
    type: POPOUT_VIEW,
    viewId
  };
};

const setLayoutSingleView = () => {
  return {
    type: SET_LAYOUT_SINGLE_VIEW
  };
};

const setLayoutTwoViewStack = () => {
  return {
    type: SET_LAYOUT_TWO_VIEW_STACK,
    viewId: uniqueId() // in case to create new view
  };
};

const setLayoutTwoViewStackThirds = () => {
  return {
    type: SET_LAYOUT_TWO_VIEW_STACK_THIRDS,
    viewId: uniqueId() // in case to create new view
  };
};

const setLayoutTwoViewSide = () => {
  return {
    type: SET_LAYOUT_TWO_VIEW_SIDE,
    viewId: uniqueId() // in case to create new view
  };
};

const setActiveView = viewId => {
  return {
    type: SET_ACTIVE_VIEW,
    viewId
  };
};

const setNextActiveView = viewId => {
  return {
    type: SET_NEXT_ACTIVE_VIEW,
    viewId
  };
};

const switchViewType = (viewType, mindmapId, viewId) => {
  return {
    type: SWITCH_VIEW_TYPE,
    viewId,
    viewType,
    mindmapId
  };
};

const switchMobilePortraitViewType = viewType => {
  return {
    type: SWITCH_MOBILE_PORTRAIT_VIEW_TYPE,
    viewType
  };
};

const switchMobileLandscapeViewType = viewType => {
  return {
    type: SWITCH_MOBILE_LANDSCAPE_VIEW_TYPE,
    viewType
  };
};

const lockScrolling = () => {
  return {
    type: LOCK_SCROLLING
  };
};

const unlockScrolling = () => {
  return {
    type: UNLOCK_SCROLLING
  };
};

const toggleRelationshipColumn = (viewId, itemId, showColumn) => {
  return {
    type: TOGGLE_RELATIONSHIP_COLUMN,
    viewId,
    itemId,
    showColumn
  };
};

const toggleExpandSuperItemInMobileList = (viewId, itemIds, isExpanded) => {
  return {
    type: TOGGLE_EXPAND_SUPER_ITEM_MOBILE_LIST,
    viewId,
    itemIds: wrapArrayIfNeeded(itemIds),
    isExpanded
  };
};

const toggleExpandSuperItem = (viewId, itemIds, isExpanded) => {
  return {
    type: TOGGLE_EXPAND_SUPER_ITEM,
    viewId,
    itemIds: wrapArrayIfNeeded(itemIds),
    isExpanded
  };
};

const changeZoomSlider = value => {
  return {
    type: CHANGE_ZOOM_SLIDER,
    value
  };
};

const defaultScrollPositionToNow = calendar =>
  defaultScrollPositionToTimestamp(dateFunctions.timestampForNow(calendar));

const defaultScrollPositionToTimestamp = timestamp => {
  return {
    type: DEFAULT_SCROLL_POSITION_TO_TIMESTAMP,
    timestamp
  };
};

const recordScrollAndZoom = (viewIds, scrollPosition, zoom) => {
  return {
    type: RECORD_SCROLL_AND_ZOOM,
    viewIds: _.isArray(viewIds) ? viewIds : [viewIds],
    scrollPosition,
    zoom
  };
};

const moveTimelineScrollPositions = seconds => {
  return {
    type: MOVE_TIMELINE_SCROLL_POSITIONS,
    seconds
  };
};

const toggleSpreadsheetColumn = (viewId, columnId, showColumn) => {
  return {
    type: TOGGLE_SPREADSHEET_COLUMN,
    viewId,
    columnId,
    showColumn
  };
};

const resizeSpreadsheetColumn = (viewId, columnId, width) => {
  return {
    type: RESIZE_SPREADSHEET_COLUMN,
    viewId,
    columnId,
    width
  };
};

const moveSpreadsheetColumn = (viewId, columnId, index) => {
  return {
    type: MOVE_SPREADSHEET_COLUMN,
    viewId,
    columnId,
    index
  };
};

const setSpreadsheetSortBy = (viewId, sortBy) => {
  return {
    type: SET_SPREADSHEET_SORT_BY,
    viewId,
    sortBy
  };
};

const toggleOutlineColumn = (viewId, columnId, showColumn) => {
  return {
    type: TOGGLE_OUTLINE_COLUMN,
    viewId,
    columnId,
    showColumn
  };
};

const resizeOutlineColumn = (viewId, columnId, width) => {
  return {
    type: RESIZE_OUTLINE_COLUMN,
    viewId,
    columnId,
    width
  };
};

const moveOutlineColumn = (viewId, columnId, index) => {
  return {
    type: MOVE_OUTLINE_COLUMN,
    viewId,
    columnId,
    index
  };
};

const toggleEntityList = typeId => {
  return {
    type: TOGGLE_ENTITY_LIST,
    typeId
  };
};

const openEntityList = typeId => {
  return {
    type: OPEN_ENTITY_LIST,
    typeId
  };
};

const toggleEntityListItem = (entityType, itemIds, isExpanding) => {
  return {
    type: TOGGLE_ENTITY_LIST_ITEM,
    entityType,
    itemIds: wrapArrayIfNeeded(itemIds),
    isExpanding
  };
};

const toggleSearchPanel = () => {
  return {
    type: TOGGLE_SEARCH_PANEL
  };
};

const openSearchPanel = () => {
  return {
    type: OPEN_SEARCH_PANEL
  };
};

const toggleFilterPanel = () => {
  return {
    type: TOGGLE_FILTER_PANEL
  };
};

const toggleGlobalFilterPanel = () => {
  return {
    type: TOGGLE_GLOBAL_FILTER_PANEL
  };
};

const toggleLocalFilterPanel = () => {
  return {
    type: TOGGLE_LOCAL_FILTER_PANEL
  };
};

const openLocalFilterPanel = () => {
  return {
    type: OPEN_LOCAL_FILTER_PANEL
  };
};

const toggleSettingsPanel = () => {
  return {
    type: TOGGLE_SETTINGS_PANEL
  };
};

//#!if harvard === true
const toggleHarvardSettingsPanel = () => {
  return {
    type: TOGGLE_HARVARD_SETTINGS_PANEL
  };
};
//#!endif

const toggleScrollToDatePanel = () => {
  return {
    type: TOGGLE_SCROLL_TO_DATE_PANEL
  };
};

const hideLeftPanel = () => {
  return {
    type: HIDE_LEFT_PANEL
  };
};

const hideDesktopLeftPanel = () => {
  return {
    type: HIDE_DESKTOP_LEFT_PANEL
  };
};

const hideTabletLeftPanel = () => {
  return {
    type: HIDE_TABLET_LEFT_PANEL
  };
};

const hideMobileLeftPanel = () => {
  return {
    type: HIDE_MOBILE_LEFT_PANEL
  };
};

const setLeftPanelMode = mode => {
  return {
    type: SET_LEFT_PANEL_MODE,
    mode: mode
  };
};

const setLeftPanelWidth = width => {
  return {
    type: SET_LEFT_PANEL_WIDTH,
    width
  };
};

const setPanelWidths = (left, right) => {
  return {
    type: SET_PANEL_WIDTHS,
    left,
    right
  };
};

const collapseFilterGroup = (filterId, groupId) => {
  return {
    type: COLLAPSE_FILTER_GROUP,
    filterId,
    groupId
  };
};

const expandFilterGroup = (filterId, groupId) => {
  return {
    type: EXPAND_FILTER_GROUP,
    filterId,
    groupId
  };
};

const changeSearchForType = (typeId, value) => {
  return {
    type: CHANGE_SEARCH_FOR_TYPE,
    typeId,
    value
  };
};

const toggleSubwayThread = (viewId, itemId, showThread) => {
  return {
    type: TOGGLE_SUBWAY_THREAD,
    viewId,
    itemId,
    showThread
  };
};

const toggleTimelineGroup = (viewId, itemOrTypeId, showGroup) => {
  return {
    type: TOGGLE_TIMELINE_GROUP,
    viewId,
    itemOrTypeId,
    showGroup
  };
};

const removeTimelineGroupsFromAllViews = itemOrTypeIds => {
  return {
    type: REMOVE_TIMELINE_GROUP_FROM_ALL_VIEWS,
    itemOrTypeIds
  };
};

const clearTimelineGroups = viewId => {
  return {
    type: CLEAR_TIMELINE_GROUPS,
    viewId
  };
};

const setFontPercentage = percentage => {
  return {
    type: SET_FONT_PERCENTAGE,
    percentage
  };
};

const userInterfaceActionPerformed = id => {
  return {
    type: USER_INTERFACE_ACTION_PERFORMED,
    id
  };
};

const addExposedFilterType = filterType => {
  return {
    type: ADD_EXPOSED_FILTER_TYPE,
    filterType
  };
};

const removeExposedFilterType = filterType => {
  return {
    type: REMOVE_EXPOSED_FILTER_TYPE,
    filterType
  };
};

export { prefix };

export default {
  selectItems,
  clearSelection,
  addItemsToSelection,
  removeItemsFromSelection,
  selectMarker,
  replaceOpenViews,
  addView,
  splitViewHorizontal,
  splitViewVertical,
  popoutView,
  minimizeView,
  removeView,
  removeOtherViews,

  setLayoutSingleView,
  setLayoutTwoViewStack,
  setLayoutTwoViewStackThirds,
  setLayoutTwoViewSide,

  setActiveView,
  setNextActiveView,
  switchViewType,
  lockScrolling,
  unlockScrolling,
  switchMobilePortraitViewType,
  switchMobileLandscapeViewType,
  toggleExpandSuperItemInMobileList,

  // zoomTimeline,
  resizeViews,
  toggleRelationshipColumn,
  toggleExpandSuperItem,
  changeZoomSlider,
  recordScrollAndZoom,
  moveTimelineScrollPositions,
  defaultScrollPositionToNow,
  defaultScrollPositionToTimestamp,
  toggleSpreadsheetColumn,
  resizeSpreadsheetColumn,
  moveSpreadsheetColumn,
  toggleOutlineColumn,
  resizeOutlineColumn,
  moveOutlineColumn,
  setSpreadsheetSortBy,

  toggleEntityList,
  openEntityList,
  toggleEntityListItem,
  toggleSearchPanel,
  openSearchPanel,
  toggleFilterPanel,
  toggleGlobalFilterPanel,
  toggleLocalFilterPanel,
  openLocalFilterPanel,
  toggleSettingsPanel,
  //#!if harvard === true
  toggleHarvardSettingsPanel,
  //#!endif
  toggleScrollToDatePanel,
  hideLeftPanel,
  hideDesktopLeftPanel,
  hideTabletLeftPanel,
  hideMobileLeftPanel,
  setLeftPanelMode,
  setLeftPanelWidth,
  setPanelWidths,

  collapseFilterGroup,
  expandFilterGroup,

  changeSearchForType,

  toggleSubwayThread,

  toggleTimelineGroup,
  clearTimelineGroups,
  removeTimelineGroupsFromAllViews,

  setFontPercentage,

  userInterfaceActionPerformed,

  addExposedFilterType,
  removeExposedFilterType
};
